import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
const pillars = [{
  number: '1',
  title: 'Identidad',
  description: 'Quién es tu avatar, a quién ayuda y cómo suena. (Sin "branding bonito" y sin frases vacías.)'
}, {
  number: '2',
  title: 'Escenas',
  description: '6–8 formatos que puedes repetir sin que se note. (Porque si no tienes escenas, te quemas.)'
}, {
  number: '3',
  title: 'Guiones',
  description: 'Estructuras de 15–45 segundos que suenan humanas. (No "IA genérica". Ritmo. Tensión. Acción mínima.)'
}];
export function SolutionSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-24 px-4 bg-black/30" data-id="element-151">
      <motion.div initial={{
      opacity: 0,
      y: 50
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 50
    }} transition={{
      duration: 0.6
    }} className="max-w-4xl mx-auto" data-id="element-152">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 text-center" data-id="element-153">
          La solución:{' '}
          <span className="text-cyan-400" data-id="element-154">el Triángulo de Consistencia</span>
        </h2>

        <p className="text-lg text-gray-300 text-center mb-16 max-w-2xl mx-auto" data-id="element-155">
          Este kit te da una estructura simple:
        </p>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-156">
          {pillars.map((pillar, index) => <motion.div key={pillar.number} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 30
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="relative" data-id="element-157">
              <div className="bg-zinc-900/50 border border-cyan-500/20 rounded-lg p-6 h-full" data-id="element-158">
                <div className="text-5xl font-bold text-cyan-400 mb-4" data-id="element-159">
                  {pillar.number}
                </div>
                <h3 className="text-2xl font-bold text-white mb-3" data-id="element-160">
                  {pillar.title}
                </h3>
                <p className="text-gray-300 leading-relaxed" data-id="element-161">
                  {pillar.description}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {
        opacity: 0
      }} transition={{
        delay: 0.8,
        duration: 0.6
      }} className="text-xl text-gray-300 text-center mt-16 font-semibold" data-id="element-162">
          Cuando esas 3 cosas existen, algo cambia:{' '}
          <span className="text-cyan-400" data-id="element-163">
            dejas de depender de motivación.
          </span>
          <br data-id="element-164" />Y empiezas a depender de un sistema.
        </motion.p>
      </motion.div>
    </section>;
}